var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompass48Line = function SvgIconCompass48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.7A16.7 16.7 0 1 1 40.7 24 16.72 16.72 0 0 1 24 40.7Zm0-30A13.3 13.3 0 1 0 37.3 24 13.31 13.31 0 0 0 24 10.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.841 33.051a2.9 2.9 0 0 1-2.74-3.82l2.69-8.09a5.35 5.35 0 0 1 3.36-3.35l8.08-2.69a2.86 2.86 0 0 1 3 .69 2.9 2.9 0 0 1 .71 3l-2.7 8.09a5.322 5.322 0 0 1-3.35 3.35l-8.09 2.7a3 3 0 0 1-.96.12Zm11.52-14.41-7.14 2.38a1.89 1.89 0 0 0-1.2 1.2l-2.38 7.14 7.14-2.38a1.89 1.89 0 0 0 1.2-1.2l2.38-7.14Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4Z",
    fill: "current"
  })));
};
export default SvgIconCompass48Line;